import React, { useEffect } from "react";
import { Button, DatePicker, Form, Input } from "antd";
import dayjs from "dayjs";
import { Localize, localizeByKeyStatic } from "components/service";
import { COMMUNICATION_DATE_FORMAT } from "../../helpers/communication-date-helper";
import type { TCommunicationFilters } from "../../helpers/communication-types-helper";

interface ICommunicationFiltersFormProps {
  filters: TCommunicationFilters;
  onApply: (values: TCommunicationFilters) => void;
  onReset: () => void;
  action?: () => void;
}

const CommunicationFiltersForm: React.FC<ICommunicationFiltersFormProps> = ({
  filters,
  onApply,
  onReset,
  action,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      ...filters,
      received_date: filters.received_date ? dayjs(filters.received_date) : undefined,
    });
  }, [filters, form]);

  return (
    <Form
      form={form}
      layout="vertical"
      className="model-form communication-filter-form"
      onFinish={(values) => {
        onApply({
          event_name: values.event_name || "",
          sender: values.sender || "",
          company_name: values.company_name || "",
          stand_number: values.stand_number || "",
          received_date: values.received_date ? values.received_date.format("YYYY-MM-DD") : undefined,
        });
        action?.();
      }}
    >
      <div className="ant-form ant-form-vertical filters-form light-theme-form">
        <Form.Item name="event_name" label={<Localize>COMMUNICATION.Filter_Event</Localize>}>
          <Input placeholder={localizeByKeyStatic("COMMUNICATION.Placeholder_FilterEvent")} />
        </Form.Item>
        <Form.Item name="sender" label={<Localize>FORMS.Input_Label_Sender</Localize>}>
          <Input placeholder={localizeByKeyStatic("COMMUNICATION.Placeholder_FilterSender")} />
        </Form.Item>
        <Form.Item name="company_name" label={<Localize>FORMS.Input_Label_CompanyName</Localize>}>
          <Input placeholder={localizeByKeyStatic("COMMUNICATION.Placeholder_FilterCompany")} />
        </Form.Item>
        <Form.Item name="stand_number" label={<Localize>FORMS.Input_Label_StandNumber</Localize>}>
          <Input placeholder={localizeByKeyStatic("COMMUNICATION.Placeholder_FilterStand")} />
        </Form.Item>
        <Form.Item name="received_date" label={<Localize>FORMS.Input_Label_ReceivedDate</Localize>}>
          <DatePicker
            style={{ width: "100%" }}
            format={COMMUNICATION_DATE_FORMAT}
            popupClassName="communication-filter-form__date-dropdown"
            placeholder={localizeByKeyStatic("COMMUNICATION.Placeholder_FilterDate")}
          />
        </Form.Item>
      </div>

      <div className="form-btn-holder">
          <Button
            className="light-bg"
            onClick={() => {
              form.resetFields();
              onReset();
              action?.();
            }}
          >
            <Localize>FORMS.Button_Text_ResetFilters</Localize>
          </Button>

          <Button className="btn-right" type="primary" htmlType="submit">
            <Localize>FORMS.Button_Text_ApplyFilters</Localize>
          </Button>
        </div>
    </Form>
  );
};

export default CommunicationFiltersForm;
